import compose from 'lodash/fp/compose';

import { canAdd, canUpdate, hasReferences, selectable } from '../plugins';
import testsApi from '../../firebase/tests';
import PluggableModule from '../pluggable';

const tests = new PluggableModule('test');

function getOwnerData(state, owner) {
  const path = `${owner}/${state[owner].selected.id}`;
  let addToOwnerMutation;
  switch (owner) {
    case 'concepts':
      addToOwnerMutation = tests.con.CONCEPT_ADD_CHILD_REF_NAMESPACED;
      break;
    default:
      throw new Error(`Invalid owner type: ${owner} for test!`);
  }

  return { path, addToOwnerMutation };
}

tests.extend({
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addTest({ commit, rootState }, { data, owner }) {
      commit(tests.con.TEST_SUBMIT_INIT);
      try {
        const { path, addToOwnerMutation } = getOwnerData(rootState, owner);
        const ref = await testsApi.add(data, path);
        commit(addToOwnerMutation, ref, { root: true });
        commit(tests.con.TEST_CREATED, ref.id);
        commit(tests.con.TEST_SUBMIT_DONE);
      } catch (error) {
        commit(tests.con.TEST_SUBMIT_DONE);
        throw error;
      }
    },
    async updateTest({ commit }, data) {
      commit(tests.con.TEST_SUBMIT_INIT);
      try {
        await testsApi.update(data);
        commit(tests.con.TEST_SUBMIT_DONE);
      } catch (error) {
        commit(tests.con.TEST_SUBMIT_DONE);
        throw error;
      }
    }
  }
});

const hop = compose(
  canAdd(),
  canUpdate(),
  selectable(testsApi, true),
  hasReferences({
    collection: 'questions',
    field: 'questions',
    parent: 'tests'
  })
);

export default hop(tests);
